import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/costCode/costCode.actions';
import { load as loadCostCodeCategories } from '../../../reducers/costCodeCategory/costCodeCategory.actions';
import { costCodes, loading } from '../../../reducers/costCode/costCode.reducer';
import { costCodeCategories } from '../../../reducers/costCodeCategory/costCodeCategory.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminCostCodes.css';
import ConnectedCostCodeForm from './CostCodeForm/CostCodeForm';
import SelectFormGroup from '../../Forms/SelectFormGroup/SelectFormGroup';

export class AdminCostCodes extends React.Component {
  constructor() {
    super();
    this.state = {
      category: undefined,
    };
  }


  componentDidMount() {
    this.props.load();
    this.props.loadCostCodeCategories();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areCostCodesLoading} />
        <Row style={{ 'margin-bottom': '15px' }}>
          <Col md={2} ><Button onClick={this.props.addCostCode} bsStyle="primary">Add New CostCode</Button></Col>
          <Col md={2}>
            <SelectFormGroup
              inputRef={(el) => { this.inputEl = el; }}
              onChange={() => this.setState({ category: this.inputEl.value })}
              options={this.props.categories}
            />
          </Col>
        </Row>
        {this.props.costCodes(this.state.category).map(costCode => (
          <Row key={costCode.id}>
            <Col>
              <ConnectedCostCodeForm costCode={costCode} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addCostCode} bsStyle="primary">Add New CostCode</Button></Col></Row>
      </span>
    );
  }
}

AdminCostCodes.propTypes = {
  load: PropTypes.func.isRequired,
  loadCostCodeCategories: PropTypes.func.isRequired,
  addCostCode: PropTypes.func.isRequired,
  areCostCodesLoading: PropTypes.bool.isRequired,
  costCodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areCostCodesLoading: loading(state),
  costCodes: categoryId => costCodes(state, categoryId),
  categories: costCodeCategories(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  loadCostCodeCategories: () => dispatch(loadCostCodeCategories()),
  addCostCode: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminCostCodes);



// WEBPACK FOOTER //
// ./src/components/Admin/CostCodes/AdminCostCodes.jsx